import React from 'react';

interface ActivityItem {
  icon: string;
  title: string;
  description: string;
  iconColor?: 'box-color-1' | 'box-color-2' | 'box-color-3' | 'box-color-4';
}

interface KidsaActivitiesProps {
  subtitle?: string;
  title?: string;
  description?: string;
  wordsbutton?: string;
  wordslink?: string;
  image?: string;
  radiusShape?: string;
  activities: ActivityItem[];
}

const KidsaActivities: React.FC<KidsaActivitiesProps> = ({
  subtitle,
  title,
  description,
  wordsbutton,
  wordslink,
  image,
  radiusShape,
  activities
}) => {
  return (
    <section className="about-activities-section section-padding pt-0" id="alumnos">
      <div className="pencil-shape">
        <img src="/assets/kidsa/assets/img/about/pencil.png" alt="shape-img" />
      </div>
      <div className="zebra-shape float-bob-y">
        <img src="/assets/kidsa/assets/img/about/cup.png" alt="shape-img" />
      </div>
      <div className="container">
        <div className="about-activities-wrapper">
          <div className="row g-4">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
              <div className="activities-img-items">
                <div className="activities-image wow fadeInUp" data-wow-delay=".3s">
                  <img src={image} alt="img" />
                </div>
                <div className="activities-image-2 wow fadeInUp" data-wow-delay=".3s"> 
                  <a href={wordslink} className="theme-btn wow fadeInUp" data-wow-delay=".7s">
                    {wordsbutton}  
                  </a>
                </div>
                <div className="radius-shape">
                  <img src={radiusShape} alt="img" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="activities-content">
                <div className="section-title">
                  <span className="wow fadeInUp">{subtitle}</span>
                  <h2 
                    className="wow fadeInUp text-transform-none" 
                    data-wow-delay=".3s"
                    dangerouslySetInnerHTML={{ __html: title }}
                  /></div>
                <p className="mt-3 mt-md-0 wow fadeInUp text-transform-none" data-wow-delay=".5s">
                  {description}
                </p>
                <div className="row g-4 mt-4">
                  {activities.map((activity, index) => (
                    <div 
                      key={index}
                      className="col-xl-6 col-lg-8 col-md-6 wow fadeInUp" 
                      data-wow-delay={`.${(index + 3) * 0.1}s`}
                    >
                      <div className="icon-items">
                        <div className={`icon ${activity.iconColor || ''}`}>
                          <i className={activity.icon}></i>
                        </div>
                        <div className="container"> {/*content pertenece a phoenix, retocar css*/}
                          <h5>{activity.title}</h5>
                          <p dangerouslySetInnerHTML={{ __html: activity.description }}></p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KidsaActivities;